import { Stack, Typography } from '@mui/material';
import { NoDataFound2 } from 'Components/NoDataFound2';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

export const NoPaymentsAndDeductionsFound = () => {
  const moduleDictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  );
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);
  const isDesktop = useIsDesktop();

  const redirects = [
    {
      text: generalDictionary.newRequestText,
      href: generalDictionary.newRequestHref,
    },
    {
      text: generalDictionary.compassRightsText,
      href: generalDictionary.compassRightsHref,
    },
    {
      text: generalDictionary.personalTeamText,
      href: generalDictionary.personalTeamHref,
    },
  ];

  return (
    <NoDataFound2
      gap={isDesktop ? '48px' : '32px'}
      redirects={redirects}
      headerComponent={
        <Stack gap='16px' alignItems={'center'} padding={'20px'}>
          <Typography
            variant='h2'
            color='text.secondary'
            alignSelf={isDesktop ? 'center' : 'flex-start'}
          >
            {moduleDictionary.title}
          </Typography>
          <Stack
            justifyContent={'center'}
            direction={isDesktop ? 'row' : 'column'}
            marginBottom={isDesktop ? '20px' : undefined}
            flexWrap={'wrap'}
          >
            <Typography
              variant='body2'
              color='text.secondary'
              marginRight={'5px'}
            >
              {moduleDictionary.noData.labels.subtitle1}
            </Typography>
            <Typography variant={'body3'} color='text.secondary'>
              {moduleDictionary.noData.labels.subtitle2}
            </Typography>
          </Stack>
        </Stack>
      }
    />
  );
};
